import React, { useEffect } from 'react';
import { find, snakeCase } from 'lodash';
import { Row, Col } from 'reactstrap';
import { Field } from '@cordata/buffet';
import { useFormikContext } from 'formik';

import { authorizedInstance as axios } from '~/utils';

import LocationForm from '~/components/Location/Form';

const yesNo = [
  'Yes',
  'No',
].map(label => ({
  label,
  value: snakeCase(label),
}));

const MedicalEventLocationForm = ({ rules = {} }) => {
  const {
    values,
    status,
    setFieldValue,
    setStatus,
  } = useFormikContext();

  useEffect(() => {
    if (values.location) {
      setFieldValue('state', values.location.attributes.provinceIso || values.location.attributes.province);
      setFieldValue('locationName', values.location.attributes.locationName);
      setFieldValue('postCode', values.location.attributes.postCode);
      setFieldValue('county', values.location.attributes.county);
      setFieldValue('city', values.location.attributes.city);
      setFieldValue('address1', values.location.attributes.addr1);
      setFieldValue('isHomeAddress', values.location.attributes.isHomeAddress
        ? find(yesNo, s => s.value === 'yes').value
        : find(yesNo, s => s.value === 'no').value);
    }
  }, [values.location]);

  const onIsHomeAddressChange = (e) => {
    if (!values.address1 && !values.postCode && !values.city && !values.state && e === 'yes') {
      setStatus({
        address: {
          loading: true,
        },
        postCode: {
          loading: true,
        },
        locationName: {
          loading: true,
        },
        county: {
          loading: true,
        },
        city: {
          loading: true,
        },
        state: {
          loading: true,
        },
      });

      axios
        .get(`/patients/${values.patient_id}/addresses`)
        .then(r => r.data.data)
        .then(r => r.filter(rr => rr.isPrimary)[0])
        .then((r) => {
          setFieldValue('locationName', r ? r.addressTypeLabel : undefined);
          setFieldValue('postCode', r ? r.postCode : undefined);
          setFieldValue('county', r ? r.county : undefined);
          setFieldValue('city', r ? r.city : undefined);
          setFieldValue('address1', r ? r.address1 : undefined);
          setFieldValue('address2', r ? r.address2 : undefined);
          setFieldValue('state', r ? r.state : undefined);
        })
        .then(() => {
          setStatus({
            address: {
              loading: false,
            },
            postCode: {
              loading: false,
            },
            locationName: {
              loading: false,
            },
            county: {
              loading: false,
            },
            city: {
              loading: false,
            },
            state: {
              loading: false,
            },
          });
        });
    }
  };

  useEffect(() => {
    if (values.isHomeAddress) {
      onIsHomeAddressChange(values.isHomeAddress);
    }
  }, [values.isHomeAddress]);

  return (
    <>
      <Row form>
        <Col sm>
          <Field
            name="isHomeAddress"
            label="Is the event location the same as their home address?"
            options={yesNo}
            type="radio-group"
            required={rules.required}
            inline
          />
        </Col>

        <Col sm>
          <Field
            name="locationName"
            loading={status && status.locationName ? status.locationName.loading : undefined}
          />
        </Col>
      </Row>

      <LocationForm />
    </>
  );
};

export default MedicalEventLocationForm;
